import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

import LoadingAssignmentContainer from '../../containers/logistics/LoadingAssignment';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';

import FMPTextField from '../../components/ui/FMPTextField';
import TerminalSupplierSelect from '../../components/form/TerminalSupplierSelect';
import ResourceUploader from '../../components/form/ResourceUploader';

const styles = (theme) => {
	return {
		tabSection: {
			backgroundColor: theme.palette.background.paper,
			width: '100%',
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
	};
};
const formFields = {
	assignedToTerminalId: '',
	assignedToSupplierId: '',
	dataFileResourceId: '',
	loadingNumbers: [''],
};

// XXX Update does not work
class SaveLoadingAssignment extends Component {
	constructor(props) {
		super(props);
		const loadingAssignmentId = _.get(this.props, ['match', 'params', 'loadingAssignmentId']);

		this.state = {
			tabIndex: 0,
			loadingAssignmentId: loadingAssignmentId ? parseInt(loadingAssignmentId, 10) : undefined,
			isUpdate: loadingAssignmentId,
			formFieldError: {},
			loadingNumbers: ['', '', '', '', '', ''],
		};
		this.state = _.merge(this.state, formFields);
	}

	componentDidMount() {
		const {
			loadingAssignment,
			getLoadingAssignment,
			stations,
			searchStations,
			carriers,
			searchCarriers,
			terminals,
			searchTerminals,
		} = this.props;

		const { isUpdate, loadingAssignmentId } = this.state;

		if (!stations.length) {
			searchStations();
		}
		if (!carriers.length) {
			searchCarriers();
		}
		if (!terminals.length) {
			searchTerminals();
		}

		//- This is an update so fetch the loading number
		if (isUpdate && !loadingAssignment) {
			getLoadingAssignment({
				params: { loadingAssignmentIds: [loadingAssignmentId] },
			});
			return;
		}

		const newState = this.getFormValuesFromLoadingAssignment({ loadingAssignment });
		this.setState(newState);
	}

	onTerminalChange = (r) => {
		let newState = {
			assignedToTerminalId: r.terminalId,
			assignedToSupplierId: r.supplierId,
		};
		newState = _.pickBy(newState, (v) => {
			return !_.isUndefined(v);
		});
		if (_.keys(newState).length) {
			this.setState(newState);
		}
	};

	handleDataFileUpload = ({ resource }) => {
		this.setState({ dataFileResourceId: resource.resourceId });
	};

	handleSave = () => {
		const { importLoadingAssignment, updateLoadingAssignment, showErrors } = this.props;

		//- Required fields
		const formFieldError = {};
		[
			{ fieldName: 'assignedToTerminalId', display: 'Terminal' },
			{ fieldName: 'assignedToSupplierId', display: 'Supplier' },
		].forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		//- Get all the values and do individual checks
		const {
			assignedToTerminalId,
			assignedToSupplierId,
			loadingAssignmentId,
			dataFileResourceId,
			isUpdate,
		} = this.state;

		let loadingNumbers = _.compact(_.uniq(this.state.loadingNumbers));

		if (!dataFileResourceId && _.isEmpty(loadingNumbers)) {
			formFieldError.dataFileResourceId = `You must upload a CVS of enter loading numbers`;
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		//- Lock and load
		const params = {
			assignedToTerminalId: parseInt(assignedToTerminalId, 10),
			assignedToSupplierId: parseInt(assignedToSupplierId, 10),
		};

		if (dataFileResourceId) {
			params.dataFileResourceId = dataFileResourceId;
		} else {
			params.loadingNumbers = loadingNumbers;
		}

		if (!isUpdate) {
			importLoadingAssignment({ params });
		} else {
			params.loadingAssignmentId = loadingAssignmentId;
			updateLoadingAssignment({ params });
		}
	};

	onChange = (event, fieldName, index) => {
		const { type, value, checked } = event.target;
		const val = type === 'checkbox' ? checked : value;
		let newState = {};

		if (!_.isNumber(index)) {
			newState = { [fieldName]: val };
		} else {
			const inputs = this.state[fieldName].slice();
			inputs[index] = val;
			newState = { [fieldName]: inputs };
		}
		this.setState(newState);
	};

	getFormValuesFromLoadingAssignment = (props) => {
		const { loadingAssignment } = props;
		if (!loadingAssignment) {
			return;
		}

		const formValues = {};
		['assignedToTerminalId', 'assignedToSupplierId', 'dataFileResourceId'].forEach((key) => {
			if (_.isNil(loadingAssignment[key])) {
				return;
			}
			formValues[key] = loadingAssignment[key];
		});
		return formValues;
	};

	addInput = (arrayName) => {
		this.setState({ [arrayName]: this.state[arrayName].concat(['']) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const {
			classes,
			loadingAssignment,
			stations,
			carriers,
			terminals,
			supplierMap,
			resourceMap,
			theme,
		} = this.props;

		const {
			isUpdate,
			loadingAssignmentId,
			assignedToTerminalId,
			assignedToSupplierId,
			dataFileResourceId,
			formFieldError,
		} = this.state;

		if (!terminals.length || !carriers.length || !stations.length) {
			return <div>Fetching information...</div>;
		}

		if (isUpdate && !loadingAssignment) {
			return <div>Fetching loading number information...</div>;
		}
		const verb = isUpdate ? 'Update' : 'Add';

		let resource;
		if (dataFileResourceId) {
			resource = resourceMap[dataFileResourceId];
			/** @namespace resource.contentType **/
			resource.isCsv = !!resource.contentType.match(/(csv)/);
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{verb} Loading Numbers {isUpdate && loadingAssignmentId}
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Assign To Ethanol Terminal / Supplier</div>

						<TerminalSupplierSelect
							label={'Ethanol Terminal'}
							supplierLabel={'Ethanol Supplier'}
							error={formFieldError['assignedToTerminalId']}
							terminalId={assignedToTerminalId}
							supplierId={assignedToSupplierId}
							onChange={this.onTerminalChange}
							terminals={terminals}
							supplierMap={supplierMap}
							productTypes={['etoh', 'e85']}
						/>

						<br />
						<br />
						<div className={classes.sectionHeader}>Loading Numbers</div>
						<Grid container spacing={3}>
							<Grid item xs={12} md={6}>
								<div className={classes.tabSection}>
									<AppBar position="static" color="default">
										<Tabs
											value={this.state.tabIndex}
											onChange={this.handleTabChange}
											indicatorColor="primary"
											textColor="primary"
											variant="fullWidth"
											centered
										>
											<Tab label="Upload CSV File" />
											<Tab label="Enter Manually" />
										</Tabs>
									</AppBar>
									<Paper>
										<SwipeableViews
											axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
											index={this.state.tabIndex}
											onChangeIndex={this.handleChangeTabIndex}
										>
											<TabContainer dir={theme.direction}>
												{!!resource && (
													<Grid container spacing={3} style={{ marginTop: 10 }}>
														<Grid item xs={11} md={4}>
															{resource.isCsv && (
																<div>
																	<span role="img" aria-label="success">
																		✅
																	</span>
																	File uploaded and CSV detected
																</div>
															)}
															{!resource.isCsv && (
																<div>
																	<span role="img" aria-label="warning">
																		⚠️
																	</span>
																	File uploaded but was not a valid CSV file.
																</div>
															)}
														</Grid>
														<Grid item xs={11} md={4}>
															{resource.contentType}
														</Grid>
													</Grid>
												)}

												<ResourceUploader
													name={'dataFileResourceId'}
													label={'Upload CSV File'}
													afterUpload={this.handleDataFileUpload}
													onlyOne={true}
												/>
											</TabContainer>
											<TabContainer dir={theme.direction}>
												{this.state.loadingNumbers.map((email, i) => {
													return (
														<Grid key={i} container spacing={3}>
															<FMPTextField
																name={'loadingNumbers'}
																index={i}
																label={`Loading Number ${i + 1}`}
																controller={this}
																md={5}
																contained={false}
															/>
															<Grid item xs={1}>
																<IconButton
																	color="primary"
																	className={classes.button}
																	onClick={() => this.removeInput('loadingNumbers', i)}
																>
																	<DeleteIcon />
																</IconButton>
															</Grid>
														</Grid>
													);
												})}

												<Button
													variant="contained"
													className={classes.addInputButton}
													onClick={() => this.addInput('loadingNumbers')}
												>
													ADD LOADING NUMBER
												</Button>
											</TabContainer>
										</SwipeableViews>
									</Paper>
								</div>
							</Grid>
						</Grid>

						{!isUpdate && (
							<div style={{ textAlign: 'right' }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.submitButton}
									onClick={this.handleSave}
								>
									Import Loading Numbers
								</Button>
							</div>
						)}

						{isUpdate && (
							<div style={{ paddingTop: 10, textAlign: 'right' }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.submitButton}
									onClick={() => {
										this.handleSave({ sendAlert: true });
									}}
								>
									Update Loading Numbers
								</Button>
							</div>
						)}
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

SaveLoadingAssignment.propTypes = {
	getLoadingAssignment: PropTypes.func.isRequired,
	importLoadingAssignment: PropTypes.func.isRequired,
	updateLoadingAssignment: PropTypes.func.isRequired,
	loadingAssignment: PropTypes.object,

	searchStations: PropTypes.func.isRequired,
	stations: PropTypes.array,

	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,

	supplierMap: PropTypes.object,
	resourceMap: PropTypes.object,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	LoadingAssignmentContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
])(SaveLoadingAssignment);
